import { render } from "./DateFormatter.vue?vue&type=template&id=fc484384&ts=true"
import script from "./DateFormatter.vue?vue&type=script&lang=ts"
export * from "./DateFormatter.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__